// extracted by mini-css-extract-plugin
export default {"error_text__wrapper":"styles_error_text__wrapper__4DLmz"};